import React, { Fragment, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { MAP_LOGO_BY_MODULE } from '../../../../../../components/__common/map-logo-by-provider'
import { ProviderName } from '@indigohive/cogfy-providers'
import { FieldType } from '@indigohive/cogfy-types'
import { CustomSelectionMenuItem } from '../../../../../../components/CustomSelectionMenuItem'
import { CustomMenuTitleItem } from '../../../../../../components/CustomMenuTitleItem'

export type FilteredMenuProps = {
  onChange: (event: React.ChangeEvent<HTMLSelectElement> | { target: { value: string } }) => void
  options: { value: string, label: ReactNode, disabled?: boolean, outputType?: FieldType }[]
  setSelectEl: (el: HTMLDivElement | null) => void
  searchName: string
}

export function FilteredMenu (props: FilteredMenuProps) {
  const { onChange, options, setSelectEl } = props
  const { t } = useTranslation()

  const filteredOptions = options.filter(option => option?.label?.toString().toLowerCase().includes(props.searchName.toLowerCase()))

  const optionsProviders = filteredOptions
    .map(filteredOption => filteredOption.label as string)
    .filter(filteredOption => filteredOption.includes(':'))

  const optionsProvidersNames = [...new Set(optionsProviders.map(optionProvider => optionProvider?.split(':')[0]))]

  return (
    <Fragment>
      {filteredOptions.length === 0 && (
        <li>
          <a>
            {t('No options found')}
          </a>
        </li>
      )}
      {filteredOptions
        .filter(item => !(item.label as string)?.includes(':'))
        .map(option => {
          return (
            <CustomSelectionMenuItem
              key={option.value}
              value={option.value}
              label={option.label}
              onChange={onChange}
              setSelectEl={setSelectEl}
              outputType={option.outputType}
            />
          )
        })}
      {optionsProvidersNames.map(operation => {
        const moduleName = operation?.toLocaleLowerCase().replace(' ', '')
        const imageSrc = MAP_LOGO_BY_MODULE[moduleName as ProviderName]
        return (
          <span key={operation}>
            {operation && (
              <CustomMenuTitleItem
                imageSrc={imageSrc}
                moduleLabel={operation}
                moduleName={moduleName}
              />
            )}
            {filteredOptions
              .filter(option => (option.label as string)?.split(':')[0] === operation)
              .map(operation => {
                return (
                  <CustomSelectionMenuItem
                    key={operation.value}
                    value={operation.value}
                    label={(operation.label as string)?.split(':')[1]}
                    onChange={onChange}
                    setSelectEl={setSelectEl}
                    outputType={operation.outputType}
                  />
                )
              })}
          </span>
        )
      })}
    </Fragment>
  )
}
